import { render, staticRenderFns } from "./LinkModal.vue?vue&type=template&id=882ab8ea&"
import script from "./LinkModal.vue?vue&type=script&lang=js&"
export * from "./LinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LinkModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/LinkModal.vue
// module id = 2328
// module chunks = 1